module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.de4a911e.woff";